import versionJson from "./version.json";
import { configs } from "./deployments";

const getConfig = (url: string) => configs[url] || configs.default;

export const environment = {
  version: versionJson.version,
  production: true,
  showDevEnvironment: false,
  config: getConfig(globalThis.location.hostname),
};
